import { Injectable } from '@angular/core';

import { retryStrategy } from '@personal-area/global/http/services';
import { UserFacade } from '@personal-area/global/users/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  catchError,
  filter,
  map,
  of,
  retryWhen,
  switchMap,
  withLatestFrom,
} from 'rxjs';

import { CardVerificationApiService } from '../../services/card-verification-api.service';
import * as cardActions from '../actions/card';

@Injectable()
export class CardVerificationEffects {
  constructor(
    private _actions$: Actions,
    private _cardVerificationApiService: CardVerificationApiService,
    private _userFacade: UserFacade,
  ) {}

  public getCard$ = createEffect(() =>
    this._actions$.pipe(
      ofType(cardActions.GetCard),
      switchMap(() => this._userId$),
      switchMap((userId) =>
        this._cardVerificationApiService.checkStatus(userId).pipe(
          map(cardActions.GetCardSuccess),
          retryWhen(retryStrategy()),
          catchError(() => of(cardActions.GetCardFail())),
        ),
      ),
    ),
  );

  private _userId$ = this._userFacade.isUserLoaded$.pipe(
    filter(Boolean),
    withLatestFrom(this._userFacade.user$, (_, { id }) => id),
  );
}
